module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ge-Ha-Ia.e900f9e4.png";